import React from "react";
import { GetServerSidePropsContext, Page } from "next";
import { useTranslation } from "@finbackoffice/site-core";
import { PopupTags, TranslationScopes } from "@finbackoffice/enums";
import { returnNotFound } from "@finbackoffice/site-server-core";
import { PolicyPagesEnum } from "@finbackoffice/fe-core";
import Seo from "components/base/seo/Seo";
import getPoliciesLayout from "components/layout/policies/PoliciesLayout";
import PoliciesSportsbook from "components/pages/policies/sportsbook/PoliciesSportsbook";
import {
    clientBFFSingleton,
    getServerData,
    createGetServerSideProps,
    CommonSsrProps,
    getServerRuntimeConfig,
} from "services/ssr";
import { getCurrentLocale } from "utils/helpers";

export const getServerSideProps = createGetServerSideProps<CommonSsrProps>(
    async (context: GetServerSidePropsContext) => {
        const runtimeConfig = await getServerRuntimeConfig();
        const client = clientBFFSingleton.getInstance(context.req.cookies.jwt);
        const locale = getCurrentLocale(runtimeConfig, context.locale);

        const isPageEnabled = runtimeConfig.COMMON_SITE_CONFIGS._policies.find(
            (config) => config.name === PolicyPagesEnum.Sports,
        )?.enable;

        if (!isPageEnabled) {
            return returnNotFound();
        }

        const { translations, configs, profile, popupBanners } = await getServerData(
            runtimeConfig,
            context,
            client,
            {
                translationScope: [
                    TranslationScopes.Policies,
                    TranslationScopes.PoliciesSportsbook,
                ],
                popupBanners: { device: PopupTags.Desktop },
            },
        );

        return {
            props: {
                configs,
                runtimeConfig,
                jwt: context.req.cookies.jwt || "",
                profile: profile || null,
                locale,
                translations,
                popupBanners: popupBanners || [],
            },
        };
    },
);

const PoliciesSportsbookPage: Page = () => {
    const { t } = useTranslation();
    return (
        <>
            <Seo
                page={TranslationScopes.PoliciesSportsbook}
                replace={{
                    title: {
                        page_name: t("pageName_policies_rules"),
                    },
                }}
            />
            <PoliciesSportsbook />
        </>
    );
};

PoliciesSportsbookPage.getLayout = getPoliciesLayout;

export default PoliciesSportsbookPage;
